import React from 'react';

import BiopharmaGroupsStatsLoader from './BiopharmaGroupsStatsLoader';
import { useJobProspectsStatsState, useJobProspectsStatsActions } from './JobProspectsStatsContext';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import { scheduleBiopharmaWebpageCaching } from './restApi';
import styles from './BiopharmaGroupsStats.module.scss';

const BiopharmaGroupsStats = () => {
  const state = useJobProspectsStatsState();
  const { onResponse, onError } = useJobProspectsStatsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleCaching = () => {
    scheduleBiopharmaWebpageCaching({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <BiopharmaGroupsStatsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Biopharma Groups Statistics" />
          <div style={{ marginBottom: '1rem' }}>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats'}
            >
              ← Back to Stats Overview
            </Button>
          </div>

          {state?.loading && <p>Loading...</p>}

          {!state?.loading && (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem' }}>
                <p><strong>Total Biopharma Groups:</strong> {state?.total}</p>
                <p><strong>Massachusetts Biopharma Groups:</strong> {state?.ma_groups}</p>
                <p><strong>United States Biopharma Groups:</strong> {state?.us_groups}</p>
                <p><strong>Groups with Weblinks:</strong> {state?.groups_with_weblinks}</p>
                <p><strong>Groups with External Job Boards:</strong> {state?.groups_with_external_job_boards}</p>
              </div>

              <ActionRow>
                <Button onClick={handleScheduleCaching}>
                  Cache All MA Group Webpages
                </Button>
              </ActionRow>
            </>
          )}
        </Stack>
      </div>
    </>
  );
};

export default BiopharmaGroupsStats;
